import { render, staticRenderFns } from "./integrationsDetailView.vue?vue&type=template&id=df34c13c&"
import script from "./integrationsDetailView.vue?vue&type=script&lang=js&"
export * from "./integrationsDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports